import "./Tag.scss"

import React, { FunctionComponent } from "react"

import Text from "components/Text/Text"
import iconRemoveTagWhite from "assets/img/icon-remove-tag-white.svg"
import iconRemoveTag from "assets/img/icon-remove-tag.svg"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"

export enum TagTheme {
    default = "default",
    bordered = "bordered",
    transparent = "transparent"
}

export interface ITagProps {
    label: string,
    theme?: TagTheme
    crossIcon?: boolean
    onClick?(): void
}

const Tag: FunctionComponent<React.PropsWithChildren<ITagProps>> = ({
    label,
    theme = TagTheme.default,
    crossIcon,
    onClick,
}) => (
    <div className={`tag tag--theme-${theme} ${onClick ? 'tag--clickable' : ''} ${crossIcon ? 'tag--with-cross-icon' : ''}`}
        onClick={onClick}
        data-testid="tag">
        <Text className="tag__text"><FlexibleContent text={label} /></Text>
        {crossIcon &&
            <div className="tag__close">
                <img
                    src={theme === TagTheme.transparent ? iconRemoveTag : iconRemoveTagWhite}
                    className="tag__close-img"
                    alt="×" />
            </div>
        }
    </div>
)

export default Tag
